import { FeatureIslandMainWithCategoryWrapper } from "@/components/features/_layouts";

import { QuestionOptionSubOption as Question } from "./settings/root";

import type { StandardOptionI18nCategoriesAndManagerStore } from "../../store/categories";

type Props = {
	subOption: StandardOptionI18nCategoriesAndManagerStore["subOption"];
};

export const QuestionOptionI18nSubOption = ({ subOption }: Props) => {
	return (
		<FeatureIslandMainWithCategoryWrapper categoryStore={subOption}>
			<Question />
		</FeatureIslandMainWithCategoryWrapper>
	);
};

QuestionOptionI18nSubOption.displayName = "QuestionOptionI18nSubOption";
